module.exports = __webpack_public_path__ + "img/lead-02e.2c7fc164.png";